import { createReducer, on } from '@ngrx/store';

import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import { upsellOrderMobile } from '@flight-results/mappers/flights-upsells.mapper';
import {
  fetchUpsellOptionsErrorAction, fetchUpsellOptionsSuccessAction,
  fetchPackageUpsellOptionsErrorAction, fetchPackageUpsellOptionsSuccessAction,
  fetchUpsellOptionsAction, fetchPackageUpsellOptionsAction, resetUpsellAction, fetchUpsellOptionsErrorBySectorAction
} from '@upsell/store/actions/upsell.actions';
import { mapUpsellValidOptions } from '@upsell/mappers/upsell.mapper';

export const initialState: UpsellResponse = {} as UpsellResponse;

export const upsellReducer = createReducer(
  initialState,
  on(
    resetUpsellAction,
    fetchUpsellOptionsAction,
    fetchPackageUpsellOptionsAction,
    fetchPackageUpsellOptionsErrorAction,
    fetchUpsellOptionsErrorAction,
    fetchUpsellOptionsErrorBySectorAction,
    () => initialState
  ),
  on(fetchUpsellOptionsSuccessAction, (state, { upsellOptions }) => upsellOrderMobile(mapUpsellValidOptions(upsellOptions))),
  on(fetchPackageUpsellOptionsSuccessAction, (state, { response }) => upsellOrderMobile(mapUpsellValidOptions(response))),
);
